/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listMembershipsParamsCursorMax = 512;

export const listMembershipsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listMembershipsParamsLimitDefault = 50;
export const listMembershipsParamsLimitMax = 100;

export const ListMembershipsParams = zod.object({
  includeEnded: zod.string().optional(),
  cursor: zod
    .string()
    .min(1)
    .max(listMembershipsParamsCursorMax)
    .regex(listMembershipsParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(listMembershipsParamsLimitMax)
    .default(listMembershipsParamsLimitDefault),
});

export type ListMembershipsParams = zod.input<typeof ListMembershipsParams>;
export type ListMembershipsParamsOutput = zod.output<typeof ListMembershipsParams>;
